//Importaciones
import React, { useContext } from 'react'
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MessageBox from '../../components/Common/Message/MessageBox';
import GAPBox from '../../components/Products/sKPI/GAP/GAPBox';
import GapRevisionsBox from '../../components/Products/sKPI/GAP/GapRevisionsBox';
import GapDataseriesBox from '../../components/Products/sKPI/GAP/GapDataseriesBox';
import GapDataserieFullBox from '../../components/Products/sKPI/GAP/GapDataserieFullBox';
import { useGetGapAefFishbones_AND_RevisionDataserieFullList, useGetGAPById, useGetGapRevisionDatareieList, useGetGAPElementsByGAPId, useGetListGapAnalyzeDataseriesIds, useGetGapRevisionsList } from '../../hooks/services/sKPI/useOfGAP';
import { __OBJECT_STRUCTURE_GetGAP } from '../../common/ObjectStructures/sKPI';
import MessageLastEventsBox from '../../components/Products/sKPI/GAP/MessageLastEventsBox';
import MessageLastActionsBox from '../../components/Products/sKPI/GAP/MessageLastActionsBox';
import GapActionStadistic from '../../components/Products/sKPI/GAP/GapActionStadistic';
import GapAppContext from '../../GapAppContext';
import MainAppContext from '../../MainAppContext';
import { __OBJECT_STRUCTURE_GetList } from '../../common/ObjectStructures/Trasnversal';
import { useGetUserPropsKpi } from '../../hooks/services/sPrivilege/useOfPrivilege';
import AuthVerify from '../../components/Templates/Site/AuthVerify';
import { useSelector } from 'react-redux';
import { enum__BOARD_TEMPLATE_TYPE } from '../../common/Dictionaries';

function Gap(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);

    const contextSite = useContext(MainAppContext);

    //Parametros de componente.
    const queryStringGapAnalyzeId = props.match.params.GAPId !== null && props.match.params.GAPId !== undefined && props.match.params.GAPId !== "" ? props.match.params.GAPId : null;



    const [selectedRevision, setSelectedRevision] = useState(null);
    const [selectecDataserieId, setSelectecDataserieId] = useState(null);
    const [higthLigthDataserieList, setHigthLigthDataserieList] = useState(null);
    
    const [selectedElementId, setSelectedElementId] = useState(null);
    const [elementList, setElementList] = useState(null);
    
    const [objGAP, setObjGAP] = useState(__OBJECT_STRUCTURE_GetGAP());
    useGetGAPById(queryStringGapAnalyzeId, objGAP.id, setObjGAP, null)

    const [gapElementList, setGapElementList] = useState(null);
    useGetGAPElementsByGAPId(objGAP.id, gapElementList, setGapElementList, setElementList, setSelectedElementId)

    const [gapAnalyzeDataseriesIds, setGapAnalyzeDataseriesIds] = useState(null);
    useGetListGapAnalyzeDataseriesIds(objGAP.id, selectedElementId, null, gapAnalyzeDataseriesIds, setGapAnalyzeDataseriesIds);

    const [gapRevisionsList, setGapRevisionsList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetGapRevisionsList(queryStringGapAnalyzeId, gapRevisionsList.data, setGapRevisionsList, setSelectedRevision, true) 

    const [gapRevisionDataserieList, setGapRevisionDataserieList] = useState(null);
    useGetGapRevisionDatareieList(queryStringGapAnalyzeId, selectedElementId, gapRevisionDataserieList, setGapRevisionDataserieList) 

    const [dataserieFullData, setDataserieFullData] = useState({
        revisionDataserieFullList: null,
        gapFishboneList: null,
        fireUpdateLastAction: true
    });
    useGetGapAefFishbones_AND_RevisionDataserieFullList(queryStringGapAnalyzeId, selectedElementId, selectecDataserieId, contextSite.kpiModule.boardCalendarFilterConfig.value, setDataserieFullData, dataserieFullData)

    const [userPropsKpi, setUserProps] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(enum__BOARD_TEMPLATE_TYPE.GAP, null, selectedElementId, contextSite.username, userPropsKpi, setUserProps)

    const gapContextStructure = {
        userPropsKpi: {
            value: userPropsKpi
        },
        gapElementList: {
            value: gapElementList,
            set: setGapElementList,
        },
        dataserieFullData: {
            value: dataserieFullData,
            set: setDataserieFullData,
        },
        //[##]Debe ser cargado cada vez que se seleccina una revision.
        gapRevisionDataserieList: {
            value: gapRevisionDataserieList,
            set: setGapRevisionDataserieList,
        },  
    }
    

    const [messageConfig, setMessageConfig] = useState({
        message : t('data-lang-msg-invalidboard'),
        messageType : "error",
        showMessage : true,
    });
    
    const setterSelectedRevision = (revision, _gapRevisionsList) => {
        const revisionDataseries = _gapRevisionsList.data.find(x => x.id === revision.id).l_dataserie_ids

        setSelectedRevision(revision === undefined ? null : revision)
        setHigthLigthDataserieList(revisionDataseries)
    }

    const setterDataToNull = (value) => {
        
        setDataserieFullData(prevState => ({
            ...prevState,
            revisionDataserieFullList: value === undefined ? null : value,
            gapFishboneList: null,
            fireUpdateLastAction: true
        }));
        
        setGapRevisionDataserieList(value === undefined ? null : value)
    }

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                <GapAppContext.Provider value={ gapContextStructure }>
                    {
                        userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                        <>
                            <Row>
                                <Col xl={6}>
                                    <GAPBox
                                        inputParam_GAPObject={objGAP}
                                        inputParam_SelectedElementId={selectedElementId}
                                        inputParam_SetterSelectedElementId={setSelectedElementId}
                                        inputParam_SetterGapRevisionDataserieList={setterDataToNull}
                                        inputParam_SetterGAPElements={setGapElementList}
                                        inputParam_GAPElementList={gapElementList}
                                        inputParam_FishboneList={dataserieFullData.gapFishboneList}
                                    />
                                </Col>
                                <Col xl={3}>
                                    <MessageLastActionsBox
                                        inputParam_CalledFromHome={false}
                                        inputParam_DataList={dataserieFullData.revisionDataserieFullList}
                                        inputParam_GapAnalyzeId={ parseInt(queryStringGapAnalyzeId) }
                                    />
                                </Col>

                                <Col xl={3}>
                                    <MessageLastEventsBox inputParam_CalledFromHome={false} inputParam_GapAnalyzeId={ parseInt(queryStringGapAnalyzeId) } />
                                </Col>
                            </Row>
                            
                            <Row className="pt-2">
                                <Col xl={5}>
                                    {
                                        gapRevisionsList.data &&
                                        <GapRevisionsBox
                                            inputParam_GapAnalyzeId={ parseInt(queryStringGapAnalyzeId) }
                                            inputParam_SetterSelectedRevision={ setterSelectedRevision }
                                            inputParam_GapElementId={selectedElementId}
                                            inputParam_SetterDataToNull={setterDataToNull}
                                            gapRevisionsList={gapRevisionsList}
                                            setGapRevisionsList={setGapRevisionsList}
                                        />
                                    }
                                </Col>
                                <Col xl={4}>
                                    <GapDataseriesBox
                                        inputParam_ElementList={elementList}
                                        inputParam_GapRevisionDataserieList={ gapRevisionDataserieList }
                                        inputParam_HigthLigthDataserieList={ higthLigthDataserieList }
                                    />
                                </Col>
                                <Col xl={3}>
                                    <Row className="h-100">
                                        <Col>
                                            <GapActionStadistic
                                                inputParam_GapAnalyzeId={parseInt(queryStringGapAnalyzeId)}
                                                inputParam_DataList={dataserieFullData.revisionDataserieFullList}
                                                inputParam_GapRevisionId={selectedRevision !== null ? selectedRevision.id : null}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="h-1001">
                                <Col xl={12} className="py-2 h-1001">
                                    {
                                        objGAP.id !== null &&
                                        <GapDataserieFullBox
                                            inputParam_GapAnalyzeId={ parseInt(queryStringGapAnalyzeId) }   
                                            inputParam_GapRevision={ selectedRevision }
                                            inputParam_DataserieFullData={ dataserieFullData }
                                            inputParam_GapRevisionDataserieList={ gapRevisionDataserieList }
                                            inputParam_GapElementList={ gapElementList }
                                            setterDataToNull={ setterDataToNull }
                                            setDataserieFullData={setDataserieFullData}
                                            gapAnalyzeDataseriesIds={gapAnalyzeDataseriesIds}
                                            inputParam_SetSelectecDataserieId={setSelectecDataserieId}
                                        />
                                    }
                                </Col>
                            </Row>
                        </>
                    }
                    {
                        userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                        <div className="pt-5 mt-4">
                            <MessageBox  
                                inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </div>
                    } 
                </GapAppContext.Provider>
            </>
    );
}

export default Gap;